"use client";

import type { AuthTab } from "@casino/ui/Games/hooks/useAuthGate";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@workspace/frontend-ui";
import type { FC } from "react";
import ProfileForm from "./ProfileForm";

type Props = {
  open?: boolean;
  onOpenChange: (isVisible: boolean) => void;
  authTab: AuthTab;
  onSuccess: () => void;
  dialogTitle: string;
  dialogDescription: string;
};

const DesktopAuthDialog: FC<Props> = ({
  open,
  onOpenChange,
  authTab,
  onSuccess,
  dialogTitle,
  dialogDescription,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-[425px]!">
      <DialogTitle className="sr-only">{dialogTitle}</DialogTitle>
      <DialogDescription className="sr-only">
        {dialogDescription}
      </DialogDescription>
      <ProfileForm defaultTab={authTab} onSuccess={onSuccess} />
    </DialogContent>
  </Dialog>
);

export default DesktopAuthDialog;
